import React, { Component } from "react";
import { SURGEON } from "../../services/Surgeon";
import Background from "../../assets/img/bg/login-bg.jpg";
import { Redirect } from 'react-router-dom'
import "../../assets/css/login.css";
import "../../assets/css/new_style.css";
import {CONFIG} from '../../helpers/Common';

class SurgeonLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userCredentials: {
        email: "",
        password: ""
      },
      message: "",
      user_id: "",
      roles: [],
      name: "",
      token: "",
      redirect: false,
      loginOnly: false,
    };
  }

  handleChange = e => {
    let userCredentials = this.state.userCredentials;
    userCredentials[e.target.name] = e.target.value;
    this.setState({
      userCredentials: userCredentials
    });
  };

  componentWillMount() {
    // let url = window.location.href;
    // url = url.split('/');
    // if (url[url.length - 1] == 'loginOnly') {
    //   this.setState({
    //     loginOnly: true,
    //   })
    // }
    if(localStorage.getItem('userData'))
    {
      this.setState({redirect:true})
    }
  }

  handleSubmit = e => {
    if(this.state.userCredentials.email=="")
    {
      alert('Email is Required');
    }
    else if(this.state.userCredentials.password=="")
    {
      alert('Password is Required');
    }
    else
    {
      let LoginResponse = SURGEON.login(this.state.userCredentials)
      .then(res => {
        
        if (res.data.header.error == 0) {
          let roles = res.data.body.roles;
          let loginSurgeon = false;
          for(let i =0;i<roles.length;i++)
          {
            if(roles[i]==CONFIG.CONST_SURGEON_ROLE)
            {
              loginSurgeon=true;
            }
          }
          if(loginSurgeon)
          {
            localStorage.setItem("userData", JSON.stringify(res.data.body));
            this.setState({
              redirect: true
            })
          }
          else
          {
            alert("Access Denied. Please contact to admin");
          }
         

        } else {
          alert('Invalid Email or Password')
          // console.log(res);
        }
      })
      .catch(err => {
        return err;
      });
    }
  };

  handleKeyPress = e => {
    if(e.key === 'Enter')
    {
      if(this.state.userCredentials.email=="")
      {
        alert('Email is Required');
      }
      else if(this.state.userCredentials.password=="")
      {
        alert('Password is Required');
      }
      else
      {
        this.handleSubmit();
      }
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to='/surgeon/patients' />;
    }
    var divStyle = {
      backgroundImage: `url(${Background})`
    };
    return (
      <React.Fragment>
        <section className="c-login physician-login" style={divStyle}>
          <div className="bg-overlay" />
          <div className="container">
            <div className="patient-logo">
              <img
                src={require("../../assets/img/icons/ic-login.png")}
                alt=""
              />
              <span>Patient Profile</span>
            </div>
            <div className="login-form">
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="">USERNAME</label>
                    <input
                      name="email"
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      placeholder="Email"
                      onKeyPress={this.handleKeyPress}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="">PASSWORD</label>
                    <input
                      name="password"
                      type="password"
                      placeholder="Password"
                      className="form-control"
                      onChange={this.handleChange}
                      onKeyPress={this.handleKeyPress}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-btn">
                    <button className="btn" onClick={this.handleSubmit}>
                      Submit
                    </button>
                  </div>
                  <a href="javascript: void(0);" className="forgot-password">
                    Forgot your password?
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default SurgeonLogin;
